import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getTopTalentosThunk } from "../../../store/reducers/dashboard/mejoresTalentos/mejoresTalentos.thunks";
import RankingTable from "./RankingTable";

const POPOVERS = {
  promedio: (
    <>
      Indica la posición promedio que ocupa este talento en todas las
      evaluaciones realizadas.
      <br />
      <strong>
        Mientras más cercano a 1, mayor predominancia dentro del grupo evaluado.
      </strong>
    </>
  ),
  top1: (
    <>
      Número de veces que este talento ocupó el primer lugar
      en el total de evaluaciones registradas.
    </>
  ),
};
const CardMejoresTalentos = () => {
    const dispatch = useDispatch();
    const { topTalentos, loading, error } = useSelector(
        (state) => state.mejoresTalentos
    );
    const { escuela, plantel } = useSelector((state) => state.dashboardFilters);

    useEffect(() => {
        dispatch(getTopTalentosThunk());
    }, [dispatch, escuela, plantel]);

    return (
        <RankingTable
            title="Top 5 Mejores Talentos"
            icon="solar:cup-star-bold"
            iconColor="text-warning-600"
            data={topTalentos}
            loading={loading}
            error={error}
            popovers={POPOVERS}
        />
    );
};

export default CardMejoresTalentos;